import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all trades
export const getTrades = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/trades`);
    return response.data;
  } catch (error) {
    console.error("Error fetching trades:", error.response?.data || error);
    throw error;
  }
};

// GET a single trades
export const getTradesById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/trades/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching trades:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new trades
export const createTrades = async (tradesData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/trades`, tradesData);
    return response.data;
  } catch (error) {
    console.error("Error creating trades:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing trades
export const updateTrades = async (id, tradesData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/trades/${id}`, tradesData);
    return response.data;
  } catch (error) {
    console.error("Error updating trades:", error.response?.data || error);
    throw error;
  }
};

// DELETE a trades
export const deleteTrades = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/trades/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting trades:", error.response?.data || error);
    throw error;
  }
};

// CHECK for duplicate trade code or name
export const checkDuplicateTrades = async (code, name, id) => {
  try {
    const params = new URLSearchParams();
    if (code) params.append('code', code);
    if (name) params.append('name', name);
    if (id) params.append('id', id);
    const response = await axiosInstance.get(
      `${API_URL}/trades/check-duplicate?${params.toString()}`
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error checking duplicate trades:',
      error.response?.data || error
    );
    throw error;
  }
};
